
/*global TTTimeUnitEnum */
/*eslint no-undef: "error"*/

import React from 'react';
import cx from 'classnames';
import { Dialog } from 'moovila-common';

const ConfigureStartDateReport = ({
    reportName,
    startDate,
    onChange,
    handleSubmit,
    path,
}) => {
    const dateClass = cx({
        'form-control': true,
    })
    return (
        <Dialog
            title='Configure Report'
            backTo={`${path}` ? `${path}/home` : `/home`}
            yesText='Generate Report'
            yesCallback={handleSubmit}
            disabled={startDate === ''}
        >
            <div>
                <section className='section'>
                    <div className='row'>
                        <div className='col-xs-12 form-group'>
                            <h2>{reportName}</h2>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-xs-12 form-group'>
                            <label className='text-primary' htmlFor='startDate'>Start date</label>
                            <input type="date" className={dateClass} name='startDate' onChange={onChange} value={startDate} />
                        </div>
                    </div>
                </section>
            </div>
        </Dialog>
    );
};

export default ConfigureStartDateReport;


// WEBPACK FOOTER //
// ./src/components/Reports/ConfigureStartDateReport.js